import { useEffect } from "react";

export const usePageTitle = (title) => {
  useEffect(() => {
    document.title = `${title} || Top 10 Best Irish Casinos`;
  }, [title]);
};
